export default __webpack_public_path__ + "static/media/plb-logo-mark.2d38f139.svg";